export default function (number: number, useNegativeEpsilon = false) {
  if (useNegativeEpsilon) {
    return Math.round(number * 100 - Number.EPSILON * 10 ** 6) / 100;
  } else {
    return Math.round(number * 100 + Number.EPSILON * 10 ** 6) / 100;
  }
}
